import React, { useRef, useState } from 'react';
import './ReportReview.css';
import { useSessionState } from '../../utils/usePersistedState';
import { SearchableDocViewer } from '../../components/document-utils/SearchableDocViewer';
import { isNonEmpty } from '../../utils/arrayUtils';
import { TextReview } from './TextReview';
import { ReportReviewComponent } from './ReportReview';
import { HighlightedPDFViewer } from '../../components/pdf/HighlightedPDFViewer';
import { SourcesView } from '../../components/pdf/SourcesView';
export const ReviewView = () => {
    const [reviewDocuments, setReviewDocuments] = useSessionState('reviewDocuments', []);
    const [viewDocument, setViewDocument] = useState(null);
    const [reviewKBHighlights, setReviewKBHighlights] = useState([]);
    const reviewPdfRef = useRef(null);
    const [reportDocuments, setReportDocuments] = useSessionState('reportDocuments', []);
    const [reviewReportHighlights, setReviewReportHighlights] = useState([]);
    const [currentTabIndex, setCurrentTabIndex] = useState(0);
    const onViewDocument = (document) => {
        setViewDocument(document);
    };
    const showKBHighlights = (highlights) => {
        let document = null;
        if (isNonEmpty(highlights)) {
            for (let doc of reviewDocuments) {
                if (doc.id === highlights[0].document_id) {
                    document = doc;
                    break;
                }
            }
        }
        setReviewKBHighlights(highlights);
        setViewDocument(document);
    };
    const showReportHighlights = (highlights) => {
        let document = null;
        if (isNonEmpty(highlights)) {
            for (let doc of reportDocuments) {
                if (doc.id === highlights[0].document_id) {
                    document = doc;
                    break;
                }
            }
        }
        setReviewReportHighlights(highlights);
    };
    const isReportReview = currentTabIndex === 0;
    const isTextReview = currentTabIndex === 1;
    const dropdDownItems = [
        {
            key: '1',
            label: 'Report review',
            onClick: () => {
                setCurrentTabIndex(0);
            },
            style: { fontSize: 16 },
        },
        {
            key: '2',
            label: 'Text review',
            onClick: () => {
                setCurrentTabIndex(1);
            },
            style: { fontSize: 16 },
        },
    ];
    return (React.createElement("div", { className: `review-container split`, style: { height: '90vh' } },
        React.createElement("div", { className: "review-section" }, isReportReview ? (React.createElement(ReportReviewComponent, { kbDocuments: reviewDocuments, reportHighlights: reviewReportHighlights, setReportHighlights: showReportHighlights, setKBHighlights: showKBHighlights, setTextReview: () => setCurrentTabIndex(1), dropdDownItems: dropdDownItems })) : isTextReview ? (React.createElement(TextReview, { files: reviewDocuments, highlights: reviewKBHighlights, setHighlights: showKBHighlights, dropdDownItems: dropdDownItems })) : null),
        React.createElement("div", { ref: reviewPdfRef, className: "pdf-review-section", style: {
                display: 'flex',
                flexGrow: 1,
                borderStyle: 'solid',
                borderWidth: 1,
                borderRight: 0,
                borderTop: 0,
                borderBottom: 0,
                // width: viewDocument ? '45%' : '35%',
            } }, viewDocument ? (isNonEmpty(reviewKBHighlights) ? (React.createElement(HighlightedPDFViewer, { document: viewDocument, highlights: reviewKBHighlights, onClose: () => {
                setReviewKBHighlights([]);
                setViewDocument(null);
            } })) : (React.createElement(SearchableDocViewer, { document: viewDocument, onClose: () => setViewDocument(null) }))) : (React.createElement(SourcesView, { documents: reviewDocuments, setDocuments: setReviewDocuments, onViewDocument: onViewDocument })))));
};
